module.exports = __webpack_public_path__ + "static/fonts/Montserrat300.2f354053.ttf";